export interface NewsCategory {
  slug: string;
  name: string;
  en: string;
  tagline: string;
  desc: string;
  count: number;
}

export const categories: NewsCategory[] = [
  {
    slug: "yule",
    name: "娱乐八卦",
    en: "Celebrity",
    tagline: "红毯·剧集·明星动态",
    desc: "明星动态、影视剧集与时尚潮流的第一手八卦，吃瓜不迷路。",
    count: 38,
  },
  {
    slug: "zongyi",
    name: "综艺现场",
    en: "Variety",
    tagline: "选秀·观察·慢综",
    desc: "热播综艺追踪、节目花絮与幕后的那些名场面。",
    count: 24,
  },
  {
    slug: "shehui",
    name: "社会热点",
    en: "Trending",
    tagline: "城市·生活·新风向",
    desc: "热议的社会现场与生活方式新趋势，一起围观一起聊。",
    count: 46,
  },
  {
    slug: "wangluo",
    name: "网络热梗",
    en: "Meme",
    tagline: "热梗·弹幕·冲浪文化",
    desc: "冲浪必备的网络热梗与亚文化观察，梗王都在这里。",
    count: 31,
  },
];

export function getCategory(slug: string): NewsCategory | undefined {
  return categories.find((c) => c.slug === slug);
}